import { render } from "./descripcion.vue?vue&type=template&id=5ee098b1&scoped=true"
import script from "./descripcion.vue?vue&type=script&lang=js"
export * from "./descripcion.vue?vue&type=script&lang=js"

import "./descripcion.vue?vue&type=style&index=0&id=5ee098b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee098b1"]])

export default __exports__